import {
  ENGAGEMENT__STATE_CLOSED,
  ENGAGEMENT__STATE_OPEN,
  REJECTION_REASON__10X10__BAD_MATCH,
  REJECTION_REASON__10X10__NO_MATCH,
  REJECTION_REASON__RECRUITER__MIA,
  STAGE_CONFIRMATION
} from '../../../dictionaries/Engagement.dic';
import {
  KEY__TABLE_COLLECTION__VIEW_TYPE__JOB
} from '../../../dictionaries/TableCollectionKeys.dic';
import {
  Arr
} from '../../../lib/Array.lib';
import {
  NOT
} from '../../../lib/Boolean.lib';
import getJobEntityName from '../../../lib/Job/getJobEntityName.fun';
import Box from '../../Layout/Wrappers/Box';
import TableCollection from '../../Layout/Wrappers/TableCollection';

export function JobEngagementsDetails({
  job = {},
  isDrawer = false,
}) {
  return (
    <TableCollection
      where={{ jobId: job.id }}
      filter={(data) => {
        return Arr(data).filter((model) => NOT(
          (
            (model.state === ENGAGEMENT__STATE_CLOSED)
            && [
              REJECTION_REASON__RECRUITER__MIA,
              REJECTION_REASON__10X10__BAD_MATCH,
              REJECTION_REASON__10X10__NO_MATCH
            ].includes(model.rejectionReason)
          ) || (
            (model.state === ENGAGEMENT__STATE_OPEN)
            && (model.stage === STAGE_CONFIRMATION)
          )
        ));
      }}
      title={
        <Box row w100 noWrap className='bg-white f-lg p-2'>
          <div className='fw-600 c-cyan-darker mr-1 nowrap'>
            Engagements for job:
          </div>
          <div className='c-black'>
            {getJobEntityName(job)}
          </div>
        </Box>
      }
      isDrawer={isDrawer}
      viewType={KEY__TABLE_COLLECTION__VIEW_TYPE__JOB}
    />
  );
}
